/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IBannerList {
  bannerImage?: string;
  bannerDescription?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class StoreBanner extends Component {
  private readonly storeBanners: IBannerList[] = [
    {
      bannerImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD3z8s?pubver=1',
      bannerDescription: 'Locations',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        {this.storeBanners.map((item) => (
          <div className='col-md-12'>
            <img
              className='img-responsive'
              src={item.bannerImage}
              alt={item.bannerDescription}
            />
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default StoreBanner;
